import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import EmailPulseDataGrid from '../../email-pulse-data-grid/email-pulse-data-grid.component';
import {
  getOffersDataGridColumns,
  offersColumnVisibilityModel,
} from '../offers.config';
import { EmailPulseExportMutationHook } from '../../email-pulse.types';

type OffersDataGridProps = {
  'data-testid': string;
  queryName: string;
  useExportMutation: EmailPulseExportMutationHook;
};

/**
 * Offers tab data grid component.
 * Wrapper around the generic EmailPulseDataGrid with Offers-specific configuration.
 */
const OffersDataGrid = ({
  queryName,
  useExportMutation,
  ...rest
}: OffersDataGridProps) => {
  const { t } = useTranslation();

  const columns = useMemo(() => getOffersDataGridColumns(t), [t]);

  return (
    <EmailPulseDataGrid
      columns={columns}
      columnVisibilityModel={offersColumnVisibilityModel}
      exportFileType="OFFERS"
      queryName={queryName}
      useExportMutation={useExportMutation}
      pinnedLeftColumn="title"
      {...rest}
    />
  );
};

export default OffersDataGrid;
